import Cable from 'actioncable';
import { get } from 'lodash';
import store from '../../store/index';
import {
  FETCH_CONVERSATIONS,
  ADD_NEW_MESSAGE,
  TOGGLE_CONVERSATION_BOLD,
  SET_SEEN_BY_DEALER,
} from '../../redux/Conversations';

export class Sockets {
  initializeSockets = () => {
    store.dispatch(FETCH_CONVERSATIONS());
    this.createSocket();
  }
  createSocket = () => {
    const cableUrl = process.env.NODE_ENV === 'development' ? 'ws://dealers.localhost:3000/cable' : null
    const cable = Cable.createConsumer(cableUrl);
    this.chatSubscription = cable.subscriptions.create({
      channel: 'ChatChannel',
    }, {
      received: (data) => {
        if (data.message.author === 'admin') {
          const selectedItemHashId = get(store.getState(), ['conversations', 'selectedItemHashId']);
          store.dispatch(ADD_NEW_MESSAGE({ hashId: data.conversation.offer_hash_id, data }));
          if (selectedItemHashId !== data.conversation.offer_hash_id) {
            store.dispatch(TOGGLE_CONVERSATION_BOLD({ hashId: data.conversation.offer_hash_id, value: true }));
          } else {
            store.dispatch(SET_SEEN_BY_DEALER({ conversationId: data.conversation.id }));
          }
        }
      },
    });
  }
}

export const sockets = new Sockets();
